import React from 'react';
import { PropTypes } from 'prop-types';

const statuses = {
  'info': { icon: 'fa-exclamation' }
}

function icon(status) {
  if (status) {
    return `fa ${getIcon(status)} fa-5x fa-round-border text-primary-lighten-1`;
  }

  return '';
}

function getIcon(status) {
  return statuses[status].icon;
}

const MessageContent = props => (
  <div className='modal-content message-content text-center'>
    <div className='modal-header justify-content-end pb-0'>
      <button type='button' className='close' data-dismiss='modal' aria-label='Close'>
        <span aria-hidden='true'>&times;</span>
      </button>
    </div>
    <div className='modal-body'>
      <div className="icon mb-5">
        <i className={icon(props.message.status)} aria-hidden="true"></i>
      </div>
      <div>
        <h2 className="text-primary ProximaNova-Bold">
          {props.message.title}
        </h2>
        {props.message.errorMessage}
      </div>
      {props.children}
    </div>
  </div>
);

const withSecondaryCloseButton = (WrappedComponent) => {
  return (props) => {
    return (
      <WrappedComponent {...props}>
        {props.children}
        <div className='modal-footer d-flex justify-content-center'>
          <button className="btn btn-primary px-5" onClick={props.closeModal}>
            {props.message.errorButton ? props.message.errorButton : 'Close'}
          </button>
        </div>
      </WrappedComponent>
    );
  }
}


MessageContent.propTypes = {
  message: PropTypes.shape({
    status: PropTypes.oneOf(['info']),
    title: PropTypes.string,
    errorMessage: PropTypes.string,
  }),
  closeModal: PropTypes.func
}

export default withSecondaryCloseButton(MessageContent);
export const undecorated = MessageContent;



// WEBPACK FOOTER //
// ./src/Common/Modal/MessageContent.js